<template>
  <div class="sub-page">
    <van-nav-bar :title="$t('my.withdraw')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#c9a84c" size="20" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="card form-card">
      <van-field
        v-model="withdraw_money"
        :placeholder="minAmountPlaceholder"
        type="number"
      >
        <template #button>
          <button
            type="button"
            class="all-amount-btn"
            @click.stop.prevent="fillAllAmount"
          >
            {{ $t("withdraw.all_amount") }}
          </button>
        </template>
      </van-field>
      <van-field
        v-model="paypassword"
        :placeholder="$t('q15')"
        type="password"
      />
    </div>

    <div class="card info-card">
      <div class="row">
        <span>{{ $t("my.balance") }}：</span>
        <span class="num">{{ userInfo.money || "0.00" }}{{ $t("reservation.ge") }}</span>
      </div>
      <div class="row">{{ $t("q16") }}：{{ userInfo.name || "-" }}</div>
      <div class="row bank">
        <span class="dot"></span>
        {{ $t("q17") }} ：{{ bankInfo.bankinfo || "-" }}
        {{ bankInfo.fhnumber || "" }}
      </div>
    </div>

    <div class="sub-btn" @click="doWithdraw()">{{ $t("q18") }}</div>

    <div class="card tip-card">
      <div class="tip-title">{{ $t("q19") }}：</div>
      <div class="tip-line">1、{{ $t("q20") }}{{ withdrawRole.max }}</div>
      <div class="tip-line">2、{{ $t("q21") }}{{ withdrawRole.min }}</div>
      <div class="tip-line">3、{{ $t("q22") }}</div>
      <div class="tip-line">4、{{ $t("q23") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paypassword: "",
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      bankInfo: {},
    };
  },
  computed: {
    minAmountPlaceholder() {
      const min = this.withdrawRole && this.withdrawRole.min;
      const val =
        min === undefined || min === null || min === "" ? "0.00" : min;
      return `${this.$t("q14")}${val}`;
    },
  },
  methods: {
    getUserBankInfo() {
      this.$http({ method: "get", url: "user_get_bank" }).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.is_bank) {
            this.bankInfo = res.data.info || {};
          } else {
            this.$toast.fail(this.$t("setting.set_bank"));
            this.$router.replace({ path: "/Setbank" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    back() {
      return window.history.back();
    },
    fillAllAmount() {
      const money = this.userInfo && this.userInfo.money;
      if (money === undefined || money === null || money === "") {
        this.$toast(this.$t("setting.correct_money"));
        return;
      }
      const n = Number(money);
      if (isNaN(n) || n <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return;
      }
      this.withdraw_money = String(n);
    },
    getUserInfo() {
      this.$http({ method: "get", url: "user_info" }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data || {};
          if (!this.userInfo.paypassword) {
            this.$toast.fail(this.$t("setting.set_withdraw_pwd"));
            this.$router.replace({ path: "/SetPayPassword" });
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({ method: "get", url: "user_get_withdraw_role" }).then((res) => {
        if (res.code === 200) {
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    doWithdraw() {
      if (Number(this.userInfo.close_withdraw) === 1) {
        this.$toast.fail(this.$t("setting.funds_frozen"));
        return false;
      }
      if (!this.userInfo.paypassword) {
        this.$toast.fail(this.$t("setting.set_withdraw_pwd"));
        this.$router.push({ path: "/SetPayPassword" });
        return false;
      }
      if (!this.paypassword) {
        this.$toast(this.$t("q24"));
        return false;
      }
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }
      this.$http({
        method: "post",
        data: { money: this.withdraw_money, paypassword: this.paypassword },
        url: "user_set_withdraw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.getUserInfo();
          this.getUserWithdrawRole();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
  mounted() {
    this.getUserBankInfo();
  },
};
</script>

<style lang="less" scoped>
.sub-page {
  min-height: 100vh;
  background: #000000;
  padding-bottom: 40px;
}
.card {
  background: #141414;
  border-radius: 16px;
  margin: 24px 24px 0;
  overflow: hidden;
}
.form-card {
  /deep/ .van-cell {
    padding: 28px 28px;
    font-size: 30px;
  }
  .all-amount-btn {
    appearance: none;
    border: none;
    outline: none;
    background: #c9a84c;
    color: #000;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    padding: 14px 20px;
    border-radius: 24px;
    white-space: nowrap;
  }
}
.info-card {
  padding: 28px;
  color: #c9a84c;
  font-size: 28px;
  .row {
    margin-bottom: 18px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .num {
    color: #c9a84c;
    font-weight: 700;
  }
  .bank {
    color: #666;
    display: flex;
    align-items: center;
  }
  .dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 6px solid #c9a84c;
    margin-right: 12px;
    box-sizing: border-box;
    flex-shrink: 0;
  }
}
.sub-btn {
  margin: 30px 24px 0;
  height: 88px;
  line-height: 88px;
  text-align: center;
  border-radius: 44px;
  background: #c9a84c;
  color: #000;
  font-size: 32px;
  font-weight: 700;
}
.tip-card {
  padding: 28px;
  color: #666;
  font-size: 26px;
  .tip-title {
    color: #c9a84c;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .tip-line {
    line-height: 1.7;
  }
}
</style>
